import type LayerViewModel from "@esWebAPI/es/map/LayerViewModel";
import type { Criteria } from "@esWebAPI/es/model/Criteria";
import type { Attribute } from "@esWebAPI/es/model/Feature";

import AbstractFilterControl from "./AbstractFilterControl";

export default class InScheduleFilterControl extends AbstractFilterControl {
    private values: number[];

    constructor(layerViewModel: LayerViewModel, attribute: Attribute, values: number[]) {
        super(layerViewModel, "InSchedule", attribute);

        this.values = values;
    }

    toCriteria(): Criteria {
        return {
            $type: "In",
            attr: this.getAttrName(),
            values: this.values
        };
    };

    fromCriteria(criteria: Criteria) {
        this.values = criteria.values;
    }

    canRemove(): boolean {
        return false;
    }

    getTitle(): string {
        return "In Schedule";
    }

    update(featureIds: number[]) {
        this.values = featureIds;

        if (featureIds.length > 0) {
            this.eventChannel.fireEvent("onUpdate");
        } else {
            this.destroy();
        }
    }

    canLock(): boolean {
        return false;
    }

    static supportCriteria(criteria: Criteria): boolean {
        return criteria.$type === "In";
    }

    static supportAttribute(attrType: string, range): boolean {
        return attrType!= null && range == null;
    }

    static fromCriteria(layerViewModel: LayerViewModel, criteria: Criteria, attribute: Attribute): JQueryDeferred<InScheduleFilterControl> {
        return new InScheduleFilterControl(layerViewModel, attribute, []).init().done((filter: InScheduleFilterControl) => {
            filter.fromCriteria(criteria);
        });
    }

    //es.control.InScheduleFilter = InScheduleFilter;
}
